import { z } from 'zod';
export const resourceContactSchema = z.object({
    name: z.string().optional(),
    title: z.string().optional(),
    email: z.string().optional(),
    phone: z.string().optional(),
    phoneExt: z.number().optional(),
    phoneCountry: z.string().optional(),
    website: z.string().optional(),
    websiteText: z.string().optional(),
    note: z.string().optional(),
    hours: z.string().optional(),
});
export const resourceSchema = z.object({
    category: z.string(),
    description: z.string().optional(),
    order: z.number(),
    contacts: z.array(resourceContactSchema),
});
